module.exports = __webpack_public_path__ + "u.no2.a0b81013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u.no2.jpg
// module id = cJe+
// module chunks = 0